import { typography } from '@shared/tokens/typography.stylex';
import { anatomy } from '@shared/tokens/anatomy.stylex';
import { colors } from '@shared/tokens/colors.stylex';
import { fonts } from '@shared/tokens/fonts.stylex';
import * as stylex from '@stylexjs/stylex';

export const styles = stylex.create({
  container: {
    height: '100%',
    maxWidth: '560px',
    margin: '0 auto',
    fontFamily: fonts.din2014Regular,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: anatomy['size-28'],
  },
  image: {
    transform: 'rotate(15deg)',
  },
  description: {
    display: 'flex',
    flexDirection: 'column',
    gap: anatomy['size-8'],
    marginTop: anatomy['size-12'],
  },
  title: {
    fontSize: typography['fontSizeBody-2'],
    lineHeight: typography['lineHeightBody-2'],
    fontFamily: fonts.din2014Demi,
    color: colors.primaryText,
    textAlign: 'center',
  },
  subTitle: {
    fontSize: typography['fontSizeCaption-1'],
    lineHeight: typography['lineHeightCaption-1'],
    color: colors.secondaryBackground,
    textAlign: 'center',
  },
  actions: {
    display: 'flex',
    gap: anatomy['size-8'],
    ':not(#__unused__) button': {
      padding: '8px 20px',
      fontSize: typography['fontSizeCaption-1'],
      lineHeight: typography['lineHeightCaption-1'],
    },
  },
});
